/* ========================================
   NOMAD OVERLAND ADVENTURES — THEME JS
   Version: 1.0.0 | 2026-04-25
   ======================================== */

/* ---- Fixed header + announcement bar height sync ---- */
(function () {
  function syncHeights() {
    var annSection = document.getElementById('shopify-section-announcement-bar');
    var header     = document.querySelector('.site-header');

    // Announcement bar height — 0 if hidden or closed
    var annH = (annSection && annSection.offsetHeight > 0) ? annSection.offsetHeight : 0;
    // Header height
    var headerH = header ? header.offsetHeight : 72;

    document.documentElement.style.setProperty('--announcement-h', annH + 'px');
    document.documentElement.style.setProperty('--header-h', (annH + headerH) + 'px');
  }

  syncHeights();
  window.addEventListener('resize', syncHeights);

  // Re-sync after the announcement bar close animation finishes (310ms)
  var closeBtn = document.getElementById('anbar-close');
  if (closeBtn) {
    closeBtn.addEventListener('click', function () {
      setTimeout(syncHeights, 350);
    });
  }
})();

(function () {
  'use strict';

  /* ---- Announcement Bar ---- */
  const announcementClose = document.querySelector('.announcement-bar__close');
  if (announcementClose) {
    if (sessionStorage.getItem('nomad_bar_closed')) {
      const bar = document.getElementById('announcement-bar');
      if (bar) bar.style.display = 'none';
    }
    announcementClose.addEventListener('click', function () {
      const bar = document.getElementById('announcement-bar');
      if (bar) {
        bar.style.maxHeight = bar.offsetHeight + 'px';
        bar.style.overflow = 'hidden';
        bar.style.transition = 'max-height .3s ease, opacity .3s ease';
        requestAnimationFrame(() => { bar.style.maxHeight = '0'; bar.style.opacity = '0'; });
        setTimeout(() => { bar.style.display = 'none'; }, 320);
        sessionStorage.setItem('nomad_bar_closed', '1');
      }
    });
  }

  /* ---- Mobile Menu ---- */
  const menuBtn = document.querySelector('.header__menu-btn');
  const mobileNav = document.querySelector('.mobile-nav');
  const mobileOverlay = document.getElementById('mobile-overlay');
  const mobileClose = document.querySelector('.mobile-nav__close');

  function openMobileNav() {
    mobileNav && mobileNav.classList.add('is-open');
    mobileOverlay && mobileOverlay.classList.add('is-visible');
    menuBtn && menuBtn.classList.add('is-active');
    document.body.style.overflow = 'hidden';
    menuBtn && menuBtn.setAttribute('aria-expanded', 'true');
  }
  function closeMobileNav() {
    mobileNav && mobileNav.classList.remove('is-open');
    mobileOverlay && mobileOverlay.classList.remove('is-visible');
    menuBtn && menuBtn.classList.remove('is-active');
    document.body.style.overflow = '';
    menuBtn && menuBtn.setAttribute('aria-expanded', 'false');
  }

  menuBtn && menuBtn.addEventListener('click', openMobileNav);
  mobileClose && mobileClose.addEventListener('click', closeMobileNav);
  mobileOverlay && mobileOverlay.addEventListener('click', closeMobileNav);

  document.querySelectorAll('.mobile-nav__link[data-has-children]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      var item = this.closest('.mobile-nav__item');
      var submenu = item && item.querySelector('.mobile-nav__submenu');
      if (submenu) {
        var isOpen = submenu.classList.toggle('is-open');
        var chevron = this.querySelector('svg');
        if (chevron) chevron.style.transform = isOpen ? 'rotate(180deg)' : '';
        this.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      }
    });
  });

  /* ---- Search Overlay ---- */
  var searchOverlay = document.getElementById('search-overlay');
  var searchClose = document.getElementById('search-close');
  var searchInput = searchOverlay && searchOverlay.querySelector('.search-overlay__input');

  function openSearch() {
    searchOverlay && searchOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    setTimeout(function () { searchInput && searchInput.focus(); }, 100);
  }
  function closeSearch() {
    searchOverlay && searchOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  document.querySelectorAll('[data-search-trigger]').forEach(function (btn) {
    btn.addEventListener('click', openSearch);
  });
  searchClose && searchClose.addEventListener('click', closeSearch);
  searchOverlay && searchOverlay.addEventListener('click', function (e) {
    if (e.target === this) closeSearch();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeSearch(); closeMobileNav(); }
  });

  /* ---- Sticky Header ---- */
  var header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', function () {
      if (window.scrollY > 60) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }
    }, { passive: true });
  }

  /* ============================================================
   * OLD YMM FLOW — Cloudflare Worker + SEMA proxy
   * Kept (commented) as fallback. To re-enable: uncomment this block
   * AND comment out the "NEW YMM FLOW" block below it.
   * Reason for replacement: pre-warming KV cache for ~30 years ×
   * many makes/models was impractical. Now using a static JSON file
   * (ymm-data.json) generated by build-ymm-data.js — instant dropdowns,
   * no API calls for years/makes/models/submodels.
   * ============================================================ */
  if (false) { // ← disables this whole block; flip to true to re-enable old flow
  (function () {
    // ── CONFIG: paste your Cloudflare Worker URL here after deploying ────────
    var PROXY = window.NOMAD_SEMA_PROXY || '';
    // ─────────────────────────────────────────────────────────────────────────

    if (!PROXY) {
      console.warn('[YMM] NOMAD_SEMA_PROXY not set. Add it to theme settings.');
      return;
    }

    /* localStorage cache with TTL — persists across sessions so repeat visitors get instant dropdowns */
    var CACHE_TTL = {
      years:     7 * 24 * 3600 * 1000,  // 7 days
      makes:     7 * 24 * 3600 * 1000,  // 7 days
      models:    7 * 24 * 3600 * 1000,  // 7 days
      submodels: 7 * 24 * 3600 * 1000,  // 7 days
      categories:    24 * 3600 * 1000,  // 24 hours
      products:       1 * 3600 * 1000,  // 1 hour
    };

    function semaFetch(endpoint, params, _retry) {
      var qs  = new URLSearchParams(params).toString();
      var key = 'nomad_sema_' + endpoint + (qs ? '_' + qs : '');
      var ttl = CACHE_TTL[endpoint] || 3600 * 1000;

      /* Check localStorage — return immediately if data is still fresh */
      try {
        var raw = localStorage.getItem(key);
        if (raw) {
          var cached = JSON.parse(raw);
          if (cached.exp && Date.now() < cached.exp) {
            return Promise.resolve(cached.data);
          }
        }
      } catch (e) {}

      return fetch(PROXY + '/' + endpoint + (qs ? '?' + qs : ''))
        .then(function (r) {
          if (!r.ok) throw new Error('SEMA proxy error ' + r.status);
          return r.json();
        })
        .then(function (d) {
          try {
            localStorage.setItem(key, JSON.stringify({ data: d, exp: Date.now() + ttl }));
          } catch (e) {}
          return d;
        })
        .catch(function (err) {
          /* Auto-retry once after 3 seconds before giving up */
          if (!_retry) {
            return new Promise(function (resolve, reject) {
              setTimeout(function () {
                semaFetch(endpoint, params, true).then(resolve).catch(reject);
              }, 3000);
            });
          }
          return Promise.reject(err);
        });
    }

    /* Prefetch years immediately so dropdown is ready before user clicks */
    semaFetch('years').catch(function () {});

    /* Select element helpers */
    function resetSel(sel, ph) {
      if (!sel) return;
      sel.innerHTML = '<option value="">' + ph + '</option>';
      sel.disabled = true;
    }
    function loadSel(sel) {
      if (!sel) return;
      sel.innerHTML = '<option value="">Loading…</option>';
      sel.disabled = true;
    }
    function fillSel(sel, vals, ph) {
      if (!sel) return;
      sel.innerHTML = '<option value="">' + ph + '</option>';
      vals.forEach(function (v) {
        var o = document.createElement('option');
        o.value = v; o.textContent = v;
        sel.appendChild(o);
      });
      sel.disabled = !vals.length;
    }

    function showErr(form, msg) {
      clearErr(form);
      var p = document.createElement('p');
      p.className = 'ymm-error';
      p.setAttribute('role', 'alert');
      p.style.cssText = 'color:#ef4444;font-size:.8125rem;margin-top:.5rem;';
      p.textContent = msg;
      form.appendChild(p);
    }
    function clearErr(form) {
      var e = form.querySelector('.ymm-error');
      if (e) e.remove();
    }

    function initYMM(form) {
      var yearSel     = form.querySelector('[data-ymm="year"]');
      var makeSel     = form.querySelector('[data-ymm="make"]');
      var modelSel    = form.querySelector('[data-ymm="model"]');
      var submodelSel = form.querySelector('[data-ymm="submodel"]');
      var smWrap      = submodelSel ? submodelSel.closest('.hero-ymm__field, .vehicle-selector__field') : null;
      var resetBtn    = form.querySelector('[data-ymm-reset]');
      if (!yearSel) return;

      /* ── Load years from SEMA API ── */
      semaFetch('years')
        .then(function (d) {
          var years = (d.Years || d.years || []).slice().sort(function (a, b) { return b - a; });
          fillSel(yearSel, years.map(String), 'Select Year');
          yearSel.disabled = false;
        })
        .catch(function () { yearSel.disabled = false; });

      resetSel(makeSel,     'Select Make');
      resetSel(modelSel,    'Select Model');
      resetSel(submodelSel, 'Sub-Model (Optional)');
      if (smWrap) smWrap.style.display = 'none';

      /* ── Reset ── */
      if (resetBtn) {
        resetBtn.addEventListener('click', function () {
          yearSel.value = '';
          resetSel(makeSel,     'Select Make');
          resetSel(modelSel,    'Select Model');
          resetSel(submodelSel, 'Sub-Model (Optional)');
          if (smWrap) smWrap.style.display = 'none';
          clearErr(form);
        });
      }

      /* ── Year → Makes ── */
      yearSel.addEventListener('change', function () {
        clearErr(form);
        resetSel(makeSel,     'Select Make');
        resetSel(modelSel,    'Select Model');
        resetSel(submodelSel, 'Sub-Model (Optional)');
        if (smWrap) smWrap.style.display = 'none';
        if (!this.value) return;
        loadSel(makeSel);
        semaFetch('makes', { year: this.value })
          .then(function (d) {
            var names = (d.Makes || d.makes || []).map(function (m) {
              return typeof m === 'object' ? (m.MakeName || m.makeName || m.name) : m;
            }).filter(Boolean).sort();
            names.length ? fillSel(makeSel, names, 'Select Make') : resetSel(makeSel, 'No makes found');
          })
          .catch(function () { resetSel(makeSel, 'Select Make'); makeSel.disabled = false; });
      });

      /* ── Make → Models ── */
      if (makeSel) {
        makeSel.addEventListener('change', function () {
          clearErr(form);
          resetSel(modelSel,    'Select Model');
          resetSel(submodelSel, 'Sub-Model (Optional)');
          if (smWrap) smWrap.style.display = 'none';
          if (!this.value) return;
          loadSel(modelSel);
          semaFetch('models', { year: yearSel.value, make: this.value })
            .then(function (d) {
              var names = (d.Models || d.models || []).map(function (m) {
                return typeof m === 'object' ? (m.ModelName || m.modelName || m.name) : m;
              }).filter(Boolean).sort();
              names.length ? fillSel(modelSel, names, 'Select Model') : resetSel(modelSel, 'No models found');
            })
            .catch(function () { resetSel(modelSel, 'Select Model'); modelSel.disabled = false; });
        });
      }

      /* ── Model → Sub-Models (optional) ── */
      if (modelSel && submodelSel) {
        modelSel.addEventListener('change', function () {
          clearErr(form);
          resetSel(submodelSel, 'Sub-Model (Optional)');
          if (smWrap) smWrap.style.display = 'none';
          if (!this.value) return;
          semaFetch('submodels', { year: yearSel.value, make: makeSel ? makeSel.value : '', model: this.value })
            .then(function (d) {
              var names = (d.SubModels || d.subModels || d.submodels || []).map(function (s) {
                return typeof s === 'object' ? (s.SubmodelName || s.submodelName || s.name) : s;
              }).filter(Boolean).sort();
              if (names.length) {
                if (smWrap) smWrap.style.display = '';
                fillSel(submodelSel, names, 'Sub-Model (Optional)');
                submodelSel.disabled = false;
              }
            })
            .catch(function () { /* sub-model is optional — silent fail */ });
        });
      }

      /* ── Submit → go to YMM results page ── */
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        clearErr(form);
        var year     = yearSel.value;
        var make     = makeSel     ? makeSel.value     : '';
        var model    = modelSel    ? modelSel.value    : '';
        var submodel = submodelSel ? submodelSel.value : '';
        if (!year || !make || !model) {
          showErr(form, 'Please select a Year, Make, and Model to find parts.');
          return;
        }
        var params = new URLSearchParams({ year: year, make: make, model: model });
        if (submodel) params.set('submodel', submodel);
        window.location.href = '/pages/ymm-results?' + params.toString();
      });
    }

    document.querySelectorAll('[data-ymm-form]').forEach(initYMM);
  })();
  } // ← end of `if (false)` — old YMM flow disabled
  /* ============================================================
   * NEW YMM FLOW — Static JSON Data (from theme assets)
   * Loads ymm-data.json once (~1–2 MB, served from Shopify CDN,
   * gzip-compressed, cached forever by the browser). All dropdown
   * filtering happens in-memory — zero API calls, zero latency.
   *
   * Data shape:
   *   {
   *     years:     [2024, 2023, ...],
   *     makes:     { "2024": ["Toyota","Jeep",...] },
   *     models:    { "2024|Toyota": ["Tacoma","4Runner",...] },
   *     submodels: { "2024|Toyota|Tacoma": ["TRD Off-Road",...] }
   *   }
   * Regenerate with:  node build-ymm-data.js
   * ============================================================ */
  (function () {
    var DATA_URL = window.NOMAD_YMM_DATA_URL || '/assets/ymm-data.json';

    /* Shared promise — every form on the page waits on the same fetch */
    var _dataPromise = null;
    function loadData() {
      if (_dataPromise) return _dataPromise;
      _dataPromise = fetch(DATA_URL, { cache: 'force-cache' })
        .then(function (r) {
          if (!r.ok) throw new Error('ymm-data.json HTTP ' + r.status);
          return r.json();
        })
        .catch(function (err) {
          console.warn('[YMM] Failed to load ymm-data.json:', err);
          _dataPromise = null;
          return null;
        });
      return _dataPromise;
    }

    /* Prefetch immediately so it's in browser cache before user opens selector */
    loadData();

    /* Select element helpers */
    function resetSel(sel, ph) {
      if (!sel) return;
      sel.innerHTML = '<option value="">' + ph + '</option>';
      sel.disabled = true;
    }
    function fillSel(sel, vals, ph) {
      if (!sel) return;
      sel.innerHTML = '<option value="">' + ph + '</option>';
      vals.forEach(function (v) {
        var o = document.createElement('option');
        o.value = v; o.textContent = v;
        sel.appendChild(o);
      });
      sel.disabled = !vals.length;
    }
    function showErr(form, msg) {
      clearErr(form);
      var p = document.createElement('p');
      p.className = 'ymm-error';
      p.setAttribute('role', 'alert');
      p.style.cssText = 'color:#ef4444;font-size:.8125rem;margin-top:.5rem;';
      p.textContent = msg;
      form.appendChild(p);
    }
    function clearErr(form) {
      var e = form.querySelector('.ymm-error');
      if (e) e.remove();
    }

    function initYMM(form) {
      var yearSel     = form.querySelector('[data-ymm="year"]');
      var makeSel     = form.querySelector('[data-ymm="make"]');
      var modelSel    = form.querySelector('[data-ymm="model"]');
      var submodelSel = form.querySelector('[data-ymm="submodel"]');
      var smWrap      = submodelSel ? submodelSel.closest('.hero-ymm__field, .vehicle-selector__field') : null;
      var resetBtn    = form.querySelector('[data-ymm-reset]');
      if (!yearSel) return;

      resetSel(makeSel,     'Select Make');
      resetSel(modelSel,    'Select Model');
      resetSel(submodelSel, 'Sub-Model (Optional)');
      if (smWrap) smWrap.style.display = 'none';

      /* ── Populate years from data file ── */
      loadData().then(function (data) {
        if (!data || !data.years) { yearSel.disabled = false; return; }
        fillSel(yearSel, data.years.map(String), 'Select Year');
        yearSel.disabled = false;
      });

      /* ── Reset ── */
      if (resetBtn) {
        resetBtn.addEventListener('click', function () {
          yearSel.value = '';
          resetSel(makeSel,     'Select Make');
          resetSel(modelSel,    'Select Model');
          resetSel(submodelSel, 'Sub-Model (Optional)');
          if (smWrap) smWrap.style.display = 'none';
          clearErr(form);
        });
      }

      /* ── Year → Makes (instant, in-memory) ── */
      yearSel.addEventListener('change', function () {
        clearErr(form);
        resetSel(makeSel,     'Select Make');
        resetSel(modelSel,    'Select Model');
        resetSel(submodelSel, 'Sub-Model (Optional)');
        if (smWrap) smWrap.style.display = 'none';
        if (!this.value) return;
        loadData().then(function (data) {
          if (!data) return;
          var makes = (data.makes && data.makes[yearSel.value]) || [];
          makes.length ? fillSel(makeSel, makes, 'Select Make') : resetSel(makeSel, 'No makes found');
        });
      });

      /* ── Make → Models (instant, in-memory) ── */
      if (makeSel) {
        makeSel.addEventListener('change', function () {
          clearErr(form);
          resetSel(modelSel,    'Select Model');
          resetSel(submodelSel, 'Sub-Model (Optional)');
          if (smWrap) smWrap.style.display = 'none';
          if (!this.value) return;
          loadData().then(function (data) {
            if (!data) return;
            var key = yearSel.value + '|' + makeSel.value;
            var models = (data.models && data.models[key]) || [];
            models.length ? fillSel(modelSel, models, 'Select Model') : resetSel(modelSel, 'No models found');
          });
        });
      }

      /* ── Model → Sub-Models (optional, instant) ── */
      if (modelSel && submodelSel) {
        modelSel.addEventListener('change', function () {
          clearErr(form);
          resetSel(submodelSel, 'Sub-Model (Optional)');
          if (smWrap) smWrap.style.display = 'none';
          if (!this.value) return;
          loadData().then(function (data) {
            if (!data) return;
            var key = yearSel.value + '|' + makeSel.value + '|' + modelSel.value;
            var subs = (data.submodels && data.submodels[key]) || [];
            if (subs.length) {
              if (smWrap) smWrap.style.display = '';
              fillSel(submodelSel, subs, 'Sub-Model (Optional)');
              submodelSel.disabled = false;
            }
          });
        });
      }

      /* ── Submit → go to YMM results page ── */
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        clearErr(form);
        var year     = yearSel.value;
        var make     = makeSel     ? makeSel.value     : '';
        var model    = modelSel    ? modelSel.value    : '';
        var submodel = submodelSel ? submodelSel.value : '';
        if (!year || !make || !model) {
          showErr(form, 'Please select a Year, Make, and Model to find parts.');
          return;
        }
        var params = new URLSearchParams({ year: year, make: make, model: model });
        if (submodel) params.set('submodel', submodel);
        window.location.href = '/pages/ymm-results?' + params.toString();
      });
    }

    document.querySelectorAll('[data-ymm-form]').forEach(initYMM);
  })();

  /* ---- Quick Add to Cart ---- */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = this.querySelector('.product-card__add-btn');
      var originalHTML = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }

      var formData = new FormData(this);
      fetch(window.Shopify ? '/cart/add.js' : '#', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          if (btn) {
            btn.textContent = 'Added!';
            btn.style.background = '#16a34a';
            setTimeout(function () {
              btn.disabled = false;
              btn.innerHTML = originalHTML;
              btn.style.background = '';
            }, 2000);
          }
          refreshCartCount();
        })
        .catch(function () {
          if (btn) { btn.disabled = false; btn.innerHTML = originalHTML; }
        });
    });
  });

  /* ---- Cart Count ---- */
  function refreshCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var counts = document.querySelectorAll('.header__cart-count');
        counts.forEach(function (el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });
      })
      .catch(function () {});
  }

  // Init cart count
  if (typeof window.Shopify !== 'undefined') refreshCartCount();

  /* ---- Scroll Reveal ---- */
  if ('IntersectionObserver' in window) {
    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });

    document.querySelectorAll('[data-animate]').forEach(function (el) {
      revealObserver.observe(el);
    });
  } else {
    // Fallback: show all
    document.querySelectorAll('[data-animate]').forEach(function (el) {
      el.classList.add('is-visible');
    });
  }

  /* ---- Product Image Tabs (PDP) ---- */
  document.querySelectorAll('[data-tab-trigger]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var target = this.dataset.tabTarget;
      var parent = this.closest('[data-tabs]');
      if (!parent || !target) return;

      parent.querySelectorAll('[data-tab-trigger]').forEach(function (b) { b.classList.remove('is-active'); });
      parent.querySelectorAll('[data-tab-panel]').forEach(function (p) { p.hidden = true; p.classList.remove('is-active'); });

      this.classList.add('is-active');
      var panel = parent.querySelector('[data-tab-panel="' + target + '"]');
      if (panel) { panel.hidden = false; panel.classList.add('is-active'); }
    });
  });

  /* ---- Quantity Stepper ---- */
  document.querySelectorAll('.qty-stepper').forEach(function (stepper) {
    var input = stepper.querySelector('input[type="number"]');
    stepper.querySelector('[data-minus]') && stepper.querySelector('[data-minus]').addEventListener('click', function () {
      if (input) { var v = parseInt(input.value) - 1; input.value = Math.max(v, parseInt(input.min) || 1); }
    });
    stepper.querySelector('[data-plus]') && stepper.querySelector('[data-plus]').addEventListener('click', function () {
      if (input) { input.value = parseInt(input.value) + 1; }
    });
  });

  /* ---- Wishlist ---- */
  (function () {
    var KEY = 'nomad_wishlist';

    /* ── Storage helpers ── */
    function getList() {
      try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; }
    }
    function saveList(list) {
      try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    }
    function findIdx(id) {
      var list = getList(), i;
      for (i = 0; i < list.length; i++) { if (String(list[i].id) === String(id)) return i; }
      return -1;
    }
    function toggle(id, data) {
      var list = getList(), idx = findIdx(id);
      if (idx > -1) { list.splice(idx, 1); } else { list.push(data); }
      saveList(list);
      return idx === -1;
    }

    /* ── Header count ── */
    function syncCount() {
      var n = getList().length;
      document.querySelectorAll('.header__wishlist-count').forEach(function (el) {
        el.textContent = n;
        el.style.display = n > 0 ? 'flex' : 'none';
      });
      var btn = document.getElementById('header-wishlist-btn');
      if (btn) {
        if (n > 0) { btn.classList.add('has-items'); }
        else { btn.classList.remove('has-items'); }
      }
    }

    /* ── Toast notification ── */
    function toast(msg, isAdd) {
      var el = document.getElementById('wishlist-toast');
      if (!el) {
        el = document.createElement('div');
        el.id = 'wishlist-toast';
        el.style.cssText = 'position:fixed;bottom:1.5rem;right:1.5rem;z-index:9999;display:flex;align-items:center;gap:.625rem;padding:.75rem 1.25rem;border-radius:8px;font-family:var(--font-condensed,sans-serif);font-size:.875rem;font-weight:700;text-transform:uppercase;letter-spacing:.06em;box-shadow:0 8px 24px rgba(0,0,0,.5);transition:opacity .25s ease,transform .25s ease;pointer-events:none;';
        document.body.appendChild(el);
      }
      el.style.background = isAdd ? 'var(--color-primary,#97D700)' : '#444';
      el.style.color      = isAdd ? '#000' : '#fff';
      el.textContent      = msg;
      el.style.opacity    = '1';
      el.style.transform  = 'translateY(0)';
      clearTimeout(el._t);
      el._t = setTimeout(function () {
        el.style.opacity   = '0';
        el.style.transform = 'translateY(8px)';
      }, 2200);
    }

    /* ── Heart button state ── */
    function setBtnState(btn, active) {
      if (active) {
        btn.setAttribute('data-wishlisted', '1');
        btn.setAttribute('aria-label', 'Remove from wishlist');
        btn.style.opacity = '1';
        btn.style.color   = 'var(--color-primary,#97D700)';
      } else {
        btn.removeAttribute('data-wishlisted');
        btn.setAttribute('aria-label', 'Add to wishlist');
        btn.style.opacity = '';
        btn.style.color   = '';
      }
    }

    /* ── Init each product card heart ── */
    function initBtn(btn) {
      var id = btn.dataset.productId;
      if (!id) return;
      setBtnState(btn, findIdx(id) > -1);

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var d = btn.dataset;
        var data = {
          id:        d.productId,
          variantId: d.variantId  || '',
          url:       d.productUrl || '',
          title:     d.productTitle  || '',
          image:     d.productImage  || '',
          vendor:    d.productVendor || '',
          price:     d.productPrice  || ''
        };
        var added = toggle(id, data);
        setBtnState(btn, added);
        syncCount();
        btn.style.transform = 'scale(1.35)';
        setTimeout(function () { btn.style.transform = ''; }, 200);
        toast(added ? '♥ Added to wishlist' : 'Removed from wishlist', added);
      });
    }

    document.querySelectorAll('.product-card__wishlist').forEach(initBtn);
    syncCount();

    /* ── Expose globally so wishlist page can call syncCount after removing items ── */
    window.NomadWishlist = { getList: getList, saveList: saveList, syncCount: syncCount, findIdx: findIdx };
  })();

})();
